import { CaptchaError } from 'utils/errors';

export const getRecaptchaToken = (key: string): Promise<string> => {
  return new Promise<string>((resolve, reject) => {
    const handleExecuteResolve = (token: string) => {
      resolve(token);
    };

    const handleExecuteReject = () => {
      reject(new CaptchaError());
    };

    try {
      window.grecaptcha
        .execute(key, { action: 'homepage' })
        .then(handleExecuteResolve, handleExecuteReject);
    } catch (error) {
      throw new CaptchaError();
    }
  });
};
